import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReportePorObraService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/reporte-por-obra';
    this.service_url = this.api_url + this.modulo_url;
  }

  public getDefaultSchedule() {
    return {
      'obra': {},
      'resultados': {},
      'retonosHistoricos':{},
      'inversionistas': {}
    };
  }

  getObras(){
    return this.http.get(this.api_url + '/reportes/reporte-resumen-obra/obras?select=true', this.authService.getAuthHeaders());
  }

  getInversionistasByObra(idObra) {
    return this.http.get(this.service_url + '/inversionistas?idObras=' + idObra, this.authService.getAuthHeaders());
  }

  getReporte(idObra, idInversionista, fecha) {
    if (! idInversionista) {
      return this.http.get(this.service_url + '?idObras=' + idObra + '&fechaFinal=' + fecha, this.authService.getAuthHeaders());  
    }
    return this.http.get(this.service_url + '?idObras=' + idObra + '&idInversionistas=' + idInversionista + '&fechaFinal=' + fecha, this.authService.getAuthHeaders());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/reporte-por-obra.service.ts